import Queue from 'helpers/queue';
import produce from 'immer';
import { uniqBy } from 'lodash';

const queueMoveDID = new Queue();
const queueDeleteDIDList = new Queue();

// Save DID
export const baseSaveDid = () => {
  return {
    isSavingDid: false,
  };
};

export const fetchSaveDid = (actions, state) => {
  return produce(state, (draft) => {
    draft.isSavingDid = true;
  });
};

export const fetchSaveDidSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isSavingDid = false;
    draft.detailGroup.infoDidGroup.setting = actions.setting;
  });
};

export const fetchSaveDidFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isSavingDid = false;
  });
};

// Release
export const baseReleaseNow = () => {
  return {
    isReleaseNow: false,
  };
};

export const fetchReleaseNow = (actions, state) => {
  return produce(state, (draft) => {
    draft.isReleaseNow = true;
  });
};

export const fetchReleaseNowSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isReleaseNow = false;
  });
};

export const fetchReleaseNowFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isReleaseNow = false;
  });
};

// Delete dids
export const baseDeleteDid = () => {
  return {
    isDeleting: false,
    queueDidDelete: [],
  };
};

export const fetchDeleteDid = (actions, state) => {
  queueDeleteDIDList.pushToQueue(actions.id);
  return produce(state, (draft) => {
    draft.isDeleting = true;
    draft.queueDidDelete = queueDeleteDIDList.queue;
  });
};

export const fetchDeleteDidSuccess = (actions, state) => {
  queueDeleteDIDList.removeFromQueue(actions.id);
  return produce(state, (draft) => {
    draft.isDeleting = false;
    draft.queueDidDelete = queueDeleteDIDList.queue;
  });
};

export const fetchDeleteDidFailed = (actions, state) => {
  queueDeleteDIDList.removeFromQueue(actions.id);
  return produce(state, (draft) => {
    draft.isDeleting = false;
    draft.queueDidDelete = queueDeleteDIDList.queue;
  });
};

//! Dids
export const baseDids = () => {
  return {
    didsGroup: {
      isFetched: false,
      isFetching: false,
      isFetchingTotal: false,
      isLoadingMore: false,
      total: 0,
      data: [],
      error: null,
      isLast: false,
    },
  };
};

//* Get total did in account
export const fetchTotalDidInAccount = (actions, state) => {
  return produce(state, (draft) => {
    draft.didsGroup.isFetchingTotal = true;
    draft.didsGroup.error = null;
  });
};

export const fetchTotalDidInAccountSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.didsGroup.isFetchingTotal = false;
    draft.didsGroup.total = actions.total;
  });
};

export const fetchTotalDidInAccountFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.didsGroup.isFetchingTotal = false;
    draft.didsGroup.error = actions.error;
  });
};

export const fetchDidsGroup = (actions, state) => {
  return produce(state, (draft) => {
    draft.didsGroup.isFetching = true;
  });
};

export const fetchDidsGroupSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.didsGroup.isFetching = false;
    draft.didsGroup.isFetched = true;
    draft.didsGroup.data = uniqBy(actions.data, 'id');
    draft.didsGroup.isLast = actions.isLast;
  });
};

export const fetchDidsGroupFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.didsGroup.isFetching = false;
    draft.didsGroup.error = actions.error;
  });
};

export const loadMoreDidsGroup = (actions, state) => {
  return produce(state, (draft) => {
    draft.didsGroup.isLoadingMore = true;
  });
};

export const loadMoreDidsGroupSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.didsGroup.isLoadingMore = false;
    draft.didsGroup.isLast = actions.isLast;
    draft.didsGroup.data = uniqBy([...draft.didsGroup.data, ...actions.data], 'id');
  });
};

export const loadMoreDidsGroupFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.didsGroup.isLoadingMore = false;
    draft.didsGroup.error = actions.error;
  });
};

// Dids In Group
export const baseDidsInGroup = () => {
  return {
    queueMoveDidToAnotherGroup: queueMoveDID.queue,
    detailGroup: {
      isFetching: false,
      total: 0,
      data: [],
      error: null,
      infoDidGroup: {
        setting: {},
      },
    },
  };
};

export const fetchDidsInGroup = (actions, state) => {
  queueMoveDID.pushToQueue(actions.id);
  return produce(state, (draft) => {
    draft.queueMoveDidToAnotherGroup = queueMoveDID.queue;
    draft.detailGroup.isFetching = !actions.refetch;
    draft.detailGroup.isFiltering = actions.refetch;
    draft.detailGroup.error = null;
  });
};

export const fetchDidsInGroupSuccess = (actions, state) => {
  queueMoveDID.removeFromQueue(actions.id);
  return produce(state, (draft) => {
    draft.queueMoveDidToAnotherGroup = queueMoveDID.queue;
    draft.detailGroup.isFetching = false;
    draft.detailGroup.isFiltering = false;
    draft.detailGroup.total = actions.total;
    draft.detailGroup.data = actions.data;
    draft.detailGroup.infoDidGroup = actions.infoDidGroup;
  });
};

export const fetchDidsInGroupFailed = (actions, state) => {
  queueMoveDID.removeFromQueue(actions.id);
  return produce(state, (draft) => {
    draft.queueMoveDidToAnotherGroup = queueMoveDID.queue;
    draft.detailGroup.isFetching = false;
    draft.detailGroup.isFiltering = false;
    draft.detailGroup.error = actions.error;
  });
};
